"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Returns an empty object
 *
 * @module getEmptyObj
 * @func
 * @since 1.16.0
 * @return {Object}
 * @example
 *
 *     getEmptyObj(); //=> {}
 */

var getEmptyObj = function getEmptyObj() {
  return {};
};

exports.default = getEmptyObj;